import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight, FaShieldAlt, FaRocket, FaCheckCircle, FaFire, FaComments } from 'react-icons/fa';
import LandingNavbar from '../../components/layout/LandingNavbar';
import LandingFooter from '../../components/layout/LandingFooter';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      <LandingNavbar />

      <main className="landing-main">
        <div className="landing-hero">

          {/* === Colonne gauche : texte === */}
          <div className="hero-content">

            <div className="hero-badge">
              <FaFire className="badge-icon" />
              <span>L'app dating la plus fun du moment</span>
            </div>

            <h1 className="hero-title">
              Chatte, flirte &amp;
              <span className="highlight">tombe amoureux·se</span>
            </h1>

            <p className="hero-subtitle">
              Chatoo, c'est le dating sans prise de tête — chaleureux, fun et authentique.
              Rencontre des gens vrais, échange des messages spontanés et trouve ta
              moitié en quelques matches. 💛
            </p>

            <div className="hero-features">
              <div className="feature-item">
                <FaCheckCircle className="feature-icon" />
                <span>Profils vérifiés</span>
              </div>
              <div className="feature-item">
                <FaComments className="feature-icon" />
                <span>Chat en direct</span>
              </div>
              <div className="feature-item">
                <FaRocket className="feature-icon" />
                <span>Matches rapides</span>
              </div>
              <div className="feature-item">
                <FaShieldAlt className="feature-icon" />
                <span>100% sécurisé</span>
              </div>
            </div>

            <div className="hero-cta">
              <button className="btn-primary-cta" onClick={() => navigate('/register')}>
                <span>Rejoindre Chatoo — c'est gratuit</span>
                <FaArrowRight />
              </button>
              <button className="btn-secondary-cta" onClick={() => navigate('/login')}>
                <span>Se connecter</span>
              </button>
            </div>

            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">50 000+</span>
                <span className="stat-label">Rencontres</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">98%</span>
                <span className="stat-label">Satisfaits</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">24/7</span>
                <span className="stat-label">Support</span>
              </div>
            </div>
          </div>

          {/* === Colonne droite : illustration blob === */}
          <div className="hero-illustration">

            {/* Cartes flottantes */}
            <div className="floating-card">
              <span className="card-emoji">🎉</span>
              <div className="card-text-wrap">
                <span className="card-label">Nouveau</span>
                <span className="card-value">Match trouvé !</span>
              </div>
            </div>
            <div className="floating-card">
              <span className="card-emoji">💬</span>
              <div className="card-text-wrap">
                <span className="card-label">En ligne</span>
                <span className="card-value">2 400 membres</span>
              </div>
            </div>
            <div className="floating-card">
              <span className="card-emoji">❤️</span>
              <div className="card-text-wrap">
                <span className="card-label">Aujourd'hui</span>
                <span className="card-value">+340 rencontres</span>
              </div>
            </div>
            <div className="floating-card">
              <span className="card-emoji">⭐</span>
              <div className="card-text-wrap">
                <span className="card-label">Note</span>
                <span className="card-value">4.9 / 5</span>
              </div>
            </div>

            {/* Blob central animé */}
            <div className="illustration-blob">
              <span className="illustration-center">💛</span>
            </div>

            {/* Coeurs flottants */}
            <div className="floating-hearts">
              <span className="floating-heart">❤️</span>
              <span className="floating-heart">💕</span>
              <span className="floating-heart">🧡</span>
              <span className="floating-heart">💛</span>
              <span className="floating-heart">💖</span>
              <span className="floating-heart">🌸</span>
              <span className="floating-heart">💗</span>
              <span className="floating-heart">✨</span>
            </div>
          </div>

        </div>
      </main>

      <LandingFooter />
    </div>
  );
};

export default LandingPage;
